import styled from 'styled-components';
import colors from '../../colors.json';

export const ImgComunity = styled.img`
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    border: 3px solid ${colors.white};
`;
